/* ------------------------------------------------------------------------------
 *
 *  # Core Utilities Module
 *
 *  Core utility functions for template functionality
 *
 * ---------------------------------------------------------------------------- */

// Global variables - mantener compatibilidad
let isScrolled = false;
let isUpdatedDevice = false;
let isTouchEnabled = false;
const DEFAULT_THEME = 'fluent';
let isJQuery = false;

// Detect OS to apply custom scrollbars
export function detectOS() {
    const platform = window.navigator.platform,
        windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'],
        customScrollbarsClass = 'custom-scrollbars';

    // Add class if OS is windows
    windowsPlatforms.indexOf(platform) != -1 && document.documentElement.classList.add(customScrollbarsClass);
}

// Disable all transitions
export function transitionsDisabled() {
    document.body.classList.add('no-transitions');
}

// Enable all transitions
export function transitionsEnabled() {
    document.body.classList.remove('no-transitions');
}

// Export global variables for other modules
export { isScrolled, isUpdatedDevice, isTouchEnabled, DEFAULT_THEME, isJQuery };

// Set global variables (for compatibility)
export function setScrolled(value) {
    isScrolled = value;
}

export function setUpdatedDevice(value) {
    isUpdatedDevice = value;
}

export function setTouchEnabled(value) {
    isTouchEnabled = value;
}

// ✅ NUEVO: Helper para mostrar/ocultar modales de Bootstrap 5
export function showModal(modalId) {
    const modalElement = document.getElementById(modalId);
    if (modalElement) {
        const modal = bootstrap.Modal.getOrCreateInstance(modalElement);
        modal.show();
    } else {
        console.warn(`Modal ${modalId} not found`);
    }
}

export function hideModal(modalId) {
    const modalElement = document.getElementById(modalId);
    if (modalElement) {
        const modal = bootstrap.Modal.getInstance(modalElement);
        if (modal) {
            modal.hide();
        }
    } else {
        console.warn(`Modal ${modalId} not found`);
    }
}

export function setJQuery(value) {
    isJQuery = value;
}
